import PropTypes from "prop-types";

export default function FormTextarea({
  id,
  label,
  name,
  value = "",
  onChange,
  placeholder,
  rows = 4,
  disabled,
  error,
  className = "",
}) {
  const inputId = id || name;

  return (
    <div className={className}>
      <label htmlFor={inputId} className="mb-1 block text-xs font-semibold text-black">
        {label}
      </label>
      <textarea
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${inputId}-error` : undefined}
        className={[
          "min-h-[120px] w-full resize-y rounded-lg border px-3 py-2.5 text-sm outline-none transition ring-brand-600 focus:ring-2",
          error ? "border-red-400 bg-red-50/40" : "border-slate-500 bg-white",
        ].join(" ")}
      />
      {error ? (
        <p id={`${inputId}-error`} className="mt-1 text-xs font-medium text-red-600" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

FormTextarea.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
};
